
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.031.26H2a2 2 0 00-2 2v24a2 2 0 002 2h16a2 2 0 002-2V7.199h-4.969a2 2 0 01-2-2V.261zM10.6 14.949h2.869v1.25h-2.87v-1.25zm0 2.25h2.869v1.469h-2.87v-1.469zm-1.2 1.469v-1.469H6.53v1.469H9.4zm-2.869 1H9.4v1.219H6.53v-1.219zm4.069 0h2.869v1.219h-2.87v-1.219zm-1.2-4.719v1.25H6.53v-1.25H9.4zM5.03 22.386v-8.938h9.938v8.938H5.03z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.688.604l6.96 6.961","stroke":"#fff"}})])
          )
        }
      }
    